import { Icon } from "PFComponents/icon";
import { IconProps } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";

import css from "./label.module.scss";

type LabelProps = { icon?: IconProps["name"]; text: string };

export const Label = ({ text, icon }: LabelProps) => (
  <div className={css.label}>
    {icon && <Icon name={icon} size="sm" color="paletteBlue0" />}
    <Typography variant="labelRegular">{text}</Typography>
  </div>
);
